import { commandCenterLoansApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

import { CommandCenterLoadKey, markCommandCenterLoadedAction } from './loadStatus.actions';

const SKIP_FORBIDDEN_CONFIG = { skipResponseInterceptor: { forbiddenError: true } };

export const COMMAND_CENTER_CLOSING_THIS_WEEK_ACTION_TYPE = createNamedActions(
  'commandCenterClosingThisWeek',
  {
    SET_CLOSING_THIS_WEEK: 'SET_CLOSING_THIS_WEEK',
  },
);

const fetchSafe = async request => {
  try {
    const { data } = await request();

    return data ?? null;
  } catch {
    return null;
  }
};

export const getCommandCenterClosingThisWeekAction = catchAsyncActionError(() => async dispatch => {
  try {
    const data = await fetchSafe(() =>
      commandCenterLoansApi.getClosingThisWeek({ config: SKIP_FORBIDDEN_CONFIG }),
    );

    dispatch({
      type: COMMAND_CENTER_CLOSING_THIS_WEEK_ACTION_TYPE.SET_CLOSING_THIS_WEEK,
      payload: data,
    });
  } finally {
    // In a `finally` so the slice is marked loaded even when a swallowed 403/404
    // degrades to null — otherwise the zone skeleton never clears (DEV-4177).
    dispatch(markCommandCenterLoadedAction(CommandCenterLoadKey.CLOSING_THIS_WEEK));
  }
});
